import type { UserPermission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useIsPR2User = (): boolean => {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);

  const updatePermissionSelf: UserPermission = {
    resource: 'uniquepr2',
    action: 'updatebasic',
    scope: 'self',
  };

  const canUpdateSelf = useHasPermission(user, updatePermissionSelf);
  return canUpdateSelf;
};
